import { useComputed } from "@homebound/beam";
import { ListFieldState, ObjectState } from "src/utils/formState";
import { AiFieldProposalFormValue } from "./aiFieldProposalForm";
import { findAiFieldProposal } from "./bindAiProposal";

/**
 * The `ObjectState` for the AI proposal for `fieldName`, if the agent proposed one.
 */
export function useAiFieldProposalState(
  fieldProposals: ListFieldState<AiFieldProposalFormValue> | undefined,
  fieldName: string,
): ObjectState<AiFieldProposalFormValue> | undefined {
  return useComputed(() => findAiFieldProposal(fieldProposals?.rows ?? [], fieldName), [fieldProposals, fieldName]);
}
